<template>
  <div class="VcBadge" :data-qa="dataQa">
    <v-badge
      :color="`var(--${flavor})`"
      overlap
      :offset-x="offsetX"
      :offset-y="offsetY || offsetX"
      :icon="badgeIcon"
      :value="!!badgeIcon || !!badgeText"
      :left="left"
      :inline="inline"
      :content="badgeText"
      :class="`${size}`">
      <slot />
    </v-badge>
  </div>
</template>

<script>
export default {
  name: 'VcBadge',
  components: {},
  props: {
    left: {
      type: Boolean,
      required: false,
    },
    badgeText: {
      type: [String, Number],
      required: false,
    },
    badgeIcon: {
      type: String,
      required: false,
    },
    offsetX: {
      type: [Number, String],
      default: 18,
    },
    offsetY: {
      type: [Number, String],
    },
    dataQa: {
      type: String,
      default: 'VcBadge',
    },
    inline: {
      type: Boolean,
      required: false,
    },
    flavor: {
      type: String,
      default: 'red',
      validator: (type) => ['neutral', 'orange', 'red', 'blue', 'green'].includes(type),
    },
    size: {
      type: String,
      default: 'md',
      validator: (prop) => ['sm', 'md'].includes(prop),
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-icon__component {
  height: 12px;
  width: 12px;
}

.sm {
  ::v-deep .v-badge__badge {
    font-size: 11px;
    height: 16px;
    min-width: 16px;
  }
}
</style>
